import React, { Fragment, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"

import KpPos from "./KpPcPos"
import { deleteAllOrderItems } from "@redux"
import { KpFail, KpSuccess } from "components"
import KpAndroidPos from "./KpAndroidPos"

const KioskPayment = () => {
  const [t] = useTranslation()

  const dispatch = useDispatch()

  const accountId =
    useSelector(state => state.userAccountInfo._id)

  const firstPosTerminal =
    useSelector(state => state.posTerminals[accountId] || [])[0]

  const [content, setContent] = useState("payment")
  const [orderLink, setOrderLink] = useState("")

  const handleClearCart = () => {
    dispatch(
      deleteAllOrderItems()
    )
  }

  useEffect(() => {
    if (!firstPosTerminal) setContent("fail")
  }, [firstPosTerminal])

  const pcPosPayment =
    content === "payment" &&
    firstPosTerminal?.type === "pcPos"

  const androidPosPayment =
    content === "payment" &&
    firstPosTerminal?.type === "androidPos"

  return (
    <Fragment>
      {
        pcPosPayment &&
        <KpPos
          setContent={setContent}
          setOrderLink={setOrderLink}
          posTerminalDetails={firstPosTerminal}
        />
      }

      {
        androidPosPayment &&
        <KpAndroidPos
          setContent={setContent}
          setOrderLink={setOrderLink}
          posTerminalDetails={firstPosTerminal}
        />
      }

      {
        content === "success" &&
        <KpSuccess
          link={orderLink}
          onRedirect={handleClearCart}
          title={t("سفارش_شما_با_موفقیت_پرداخت_شد_از_خرید_شما_متشکریم")}
        />
      }

      {content === "fail" && <KpFail />}
    </Fragment>
  )
}

export default KioskPayment